// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__tjgEX","common":"Form_common__9iBvY","field":"Form_field__Ld+Ia","error":"Form_error__Sywrp"};